import DateHelper from './date-helper';

export function getLeadTime(mtoPricing, cond) {
  const mtoccs = mtoPricing?.['c_mtocc']?.filter(mtocc => cond?.(mtocc) ?? true) ?? [];
  return mtoccs
    .map((pricing) => pricing.c_dealerArrivalDate)
    .reduce((acc, curr) => !acc || curr < acc ? curr : acc, null);
}
  
export function getEstimatedMonth(val, locale) {
  return val ? DateHelper.getEstimatedMonth({ estimatedDate: val, locale, shouldRoundUpMonth: true }) : '';
}

export function days(startDate, endDate) {
  const diffInMs = new Date(endDate) - new Date(startDate);
  return diffInMs / (1000 * 60 * 60 * 24);
}

export function weeks(days) {
  return Math.ceil(days/7);
}